import * as React from 'react';
import { setPolicyRequirementPrompt, type PolicyAdmissionDetails } from '@cdf/api-client-react';
import { useUser } from '@/components/auth/user-provider';
import { usePolicyAdministrationContext } from '@/hooks/use-policy-administration-context';
import { PolicyAcceptanceSheet } from './policy-acceptance-sheet';
import { LegacySiteInductionSheet } from '@/components/mobile/site-induction-sheet';

export function PolicyRequirementsPrompt() {
  const user = useUser();
  const context = usePolicyAdministrationContext();
  const [prompt, setPrompt] = React.useState<{details:PolicyAdmissionDetails;approvalId?:string} | null>(null);
  const [legacy, setLegacy] = React.useState(false);
  const continuing = React.useRef(false);
  React.useEffect(() => {
    setPrompt(null); setLegacy(false);
    setPolicyRequirementPrompt((details, approvalId) => {
      // A prompt cannot submit evidence for the administrator's booked-for person.
      if (!user?.appUserId || details.beneficiaryUserId !== user.appUserId) return;
      setPrompt(current => current ?? {details,approvalId});
      setLegacy(!details.missingRules.length && !!details.legacySiteId);
    });
    return () => setPolicyRequirementPrompt(null);
  }, [context.key, user?.appUserId]);
  if (!prompt) return null;
  if (legacy) return <LegacySiteInductionSheet open siteId={prompt.details.legacySiteId ?? null} approvalId={prompt.approvalId}
    onOpenChange={open => { if (!open) setPrompt(null); }} />;
  return <PolicyAcceptanceSheet open spaceId={prompt.details.spaceId} approvalId={prompt.approvalId}
    onOpenChange={open => { if (!open && continuing.current) { continuing.current = false; return; } if (!open) setPrompt(null); }}
    onCompleted={() => {
      if (prompt.details.legacySiteId) { continuing.current = true; setLegacy(true); }
      else setPrompt(null);
    }} />;
}
